var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66675C5.40866 1.66675 1.66699 5.40841 1.66699 10.0001C1.66699 14.5917 5.40866 18.3334 10.0003 18.3334C14.592 18.3334 18.3337 14.5917 18.3337 10.0001C18.3337 5.40841 14.592 1.66675 10.0003 1.66675ZM13.9837 8.08341L9.25866 12.8084C9.14199 12.9251 8.98366 12.9917 8.81699 12.9917C8.65033 12.9917 8.49199 12.9251 8.37533 12.8084L6.01699 10.4501C5.77533 10.2084 5.77533 9.80841 6.01699 9.56675C6.25866 9.32508 6.65866 9.32508 6.90033 9.56675L8.81699 11.4834L13.1003 7.20008C13.342 6.95842 13.742 6.95842 13.9837 7.20008C14.2253 7.44175 14.2253 7.83341 13.9837 8.08341Z",
    fill: "#2E844A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircle);
export default __webpack_public_path__ + "static/media/tick-circle.ad48904d4ab769eba42851e983fe4c3f.svg";
export { ForwardRef as ReactComponent };